import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { VlanSede } from '../models/vlan-sede-dto';

@Injectable()
export class VlanSedeService {

  private urlEndPoint: string = environment.vlanSedeEndPoint;

  constructor(private http: HttpClient) { }

  listarVlanSede(): Observable<VlanSede[]> {
    return this.http.get(this.urlEndPoint + 'listar').pipe(
      map((response) => response as VlanSede[]),
    );
  }


}



// WEBPACK FOOTER //
// ./src/app/shared/services/vlanSede.service.ts